__turbopack_context__.v({
  "article-card": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__article-card",
  "article-section": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__article-section",
  "content": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__content",
  "link": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__link",
  "list": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__list",
  "thumbnail": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__thumbnail",
  "thumbnail-wrapper": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__thumbnail-wrapper",
});
